/**
 * @generated SignedSource<<200c08abb998b349360623c1e858807a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chargeamount"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "qualificationamount"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resellerprogramid"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "chargeamount",
        "variableName": "chargeamount"
      },
      {
        "kind": "Variable",
        "name": "qualificationamount",
        "variableName": "qualificationamount"
      },
      {
        "kind": "Variable",
        "name": "resellerprogramid",
        "variableName": "resellerprogramid"
      }
    ],
    "kind": "ScalarField",
    "name": "calculatevendorpayout",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "PayoutChargeRecalcQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "PayoutChargeRecalcQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "471131cbc18bf148e23c35cc01aace9e",
    "id": null,
    "metadata": {},
    "name": "PayoutChargeRecalcQuery",
    "operationKind": "query",
    "text": "query PayoutChargeRecalcQuery(\n  $resellerprogramid: UUID\n  $qualificationamount: BigFloat\n  $chargeamount: BigFloat\n) {\n  calculatevendorpayout(resellerprogramid: $resellerprogramid, qualificationamount: $qualificationamount, chargeamount: $chargeamount)\n}\n"
  }
};
})();

node.hash = "2cc0d7754bbf1298bc5cb6a7787a0f2f";

module.exports = node;
